module.exports = "/_next/static/images/b04a172bd705d6b84e95af074716edce-nubank-outdoor-md@2x.jpg";